import { PropsWithChildren } from 'react';
import { useQuery } from '@apollo/client';
import { css } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import { Tournament_GetLiveMatchsDocument } from '../Tournament.query.generated';
import { GameCard } from './GameCard';
const Link = ({
  href,
  children,
  ...rest
}: PropsWithChildren<{
  href?: string;
}>) => {
  if (!href) {
    return <div {...rest}>{children}</div>;
  }
  return <a href={href} css={css`
        display: block;
        user-select: none;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          background-color: #f7f9fc;
        }
      `} target="_blank" rel="noreferrer" {...rest} data-sentry-component="Link" data-sentry-source-file="LiveMatchsContainer.tsx">
      {children}
    </a>;
};
export type LiveMatchsContainerProps = {
  challengeId: number;
};
export const LiveMatchsContainer = ({
  challengeId
}: LiveMatchsContainerProps) => {
  const getLiveMatchsQuery = useQuery(Tournament_GetLiveMatchsDocument, {
    variables: {
      challengeId
    },
    context: {
      role: 'anonymous'
    },
    skip: !challengeId
  });
  if (getLiveMatchsQuery.data?.tournaments_game.length !== 0 && getLiveMatchsQuery.data?.tournaments_game) {
    return <>
        <Typography variant="h4" sx={{
        paddingLeft: '2rem',
        marginBottom: '0.5rem'
      }} css={css`
            @keyframes fade-in {
              0% {
                opacity: 100%;
              }

              50% {
                opacity: 40%;
              }

              100% {
                opacity: 100%;
              }
            }
          `}>
          Les matchs en cours{' '}
          <span css={css`
              animation: fade-in 1.5s linear infinite;
            `}>
            🔴
          </span>
        </Typography>
        <Box css={css`
            min-height: 8rem;
            min-width: 100vw;
            margin-bottom: 1rem;
            display: flex;
            flex-direction: row;
            overflow-x: scroll;
            padding-bottom: 0.75rem;
            margin-bottom: 1.5rem;
          `}>
          {getLiveMatchsQuery.data?.tournaments_game.map(game => <Link key={game.id} css={theme => css`
                padding: 1rem 0rem;
                border: 1px solid #e2e8ed;
                color: ${theme.vars.palette.text.primary};
                background-color: ${theme.vars.palette.background.paper};
                transition: box-shadow 0.5s cubic-bezier(0.165, 0.84, 0.44, 1),
                  background-color 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
                min-width: 20rem;
                height: 100%;
                margin: 0 0.5rem;
                border-radius: 4px;
              `} href={game?.url}>
              <GameCard game={{
            game: game
          }} />
              <div css={css`
                  text-align: center;
                  font-size: 0.75rem;
                `}>
                {[game?.place, game?.status !== 'to_come' && new Date(game?.date).toLocaleDateString([], {
              month: 'short',
              day: '2-digit'
            })].filter(Boolean).join(' - ')}
              </div>
            </Link>)}
        </Box>
      </>;
  } else {
    return null;
  }
};